import ProxyBackend from './implementation';
import AuthenticationPage from './AuthenticationPage';

export const DecapCmsBackendProxy = {
  ProxyBackend,
  AuthenticationPage,
};
export { ProxyBackend, AuthenticationPage };
